package api.traak.dto

data class UpdateProjectDTO(
    val title: String,
    val name: String,
    val phone: String,
    val locality: String,
    val street: String,
)
